//Providers routes

export const CREATE_PROVIDER = '/api/v1/providers/';
export const DELETE_PROVIDER = '/api/v1/providers/';
export const GET_PROVIDER_WORKSHOPS = '/api/v1/provider_workshops';
export const UPDATE_PROVIDER = '/api/v1/providers/';
export const GET_PROVIDERS = '/api/v1/providers/?';
export const GET_PROVIDER = '/api/v1/providers/';



// WEBPACK FOOTER //
// ./src/constants/backend_routes.js